import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinnavimumbai() {



    const cardData =
    {
        keyword: 'Force Urbania On Rent in Navi Mumbai',
        heading: 'Urbania on rent in pune: Force Urbania On Rent in Navi Mumbai',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Force Urbania On Rent in Navi Mumbai services for corporate groups, families, tourists, and event travelers commuting between Pune and Navi Mumbai. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for long‑distance travel, airport transfers, corporate outings, family trips, weddings, sightseeing, and outstation journeys from Pune to Navi Mumbai and vice versa. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Pune Airport, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, and Pimpri Chinchwad, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Force Urbania hire in Navi Mumbai.',

        top: 'Top Places to Visit in Navi Mumbai with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Pandavkada Waterfall",
    "description": "Pandavkada Waterfall, located in Kharghar, Navi Mumbai, is a stunning monsoon waterfall surrounded by lush greenery and rocky terrain. Visitors enjoy trekking, photography, and picnics while experiencing the natural beauty of the Western Ghats. The cascading water, cool breeze, and forested surroundings make it an ideal spot for adventure enthusiasts and nature lovers."
  },
  {
    "title": "Central Park, Kharghar",
    "description": "Central Park in Kharghar is one of Navi Mumbai’s largest urban parks, featuring landscaped gardens, walking paths, musical fountains, and open spaces for recreation. Families, joggers, and tourists visit for relaxation, photography, and evening strolls. The park offers a peaceful environment amidst the bustling city, making it a perfect escape into nature within Navi Mumbai."
  },
  {
    "title": "Karnala Bird Sanctuary",
    "description": "Located near Navi Mumbai, Karnala Bird Sanctuary is a haven for bird watchers and nature enthusiasts. The sanctuary features the historic Karnala Fort, dense forests, and a variety of migratory and resident bird species. Trekking trails lead to scenic viewpoints, offering panoramic views of the Western Ghats and surrounding valleys."
  },
  {
    "title": "Belapur Fort",
    "description": "Belapur Fort is a historic fortification in Navi Mumbai, offering insights into the region’s history and strategic importance. Visitors can explore the ruins, enjoy the nearby gardens, and capture panoramic views of the city and surrounding areas. It is a peaceful spot for history lovers and photographers."
  },
  {
    "title": "Kharghar Hills",
    "description": "Kharghar Hills are popular for trekking, nature walks, and scenic viewpoints overlooking Navi Mumbai. The trails pass through rocky paths, greenery, and small streams, making it ideal for adventure seekers and weekend hikers. Sunrise and sunset views from the hills are particularly mesmerizing."
  },
  {
    "title": "Sagar Vihar",
    "description": "Sagar Vihar is a serene waterfront promenade in Vashi, offering views of Thane Creek and the surrounding cityscape. Visitors enjoy walking, cycling, boating, and relaxing while watching sunsets. The landscaped areas, benches, and peaceful atmosphere make it a popular spot for families and tourists."
  },
  {
    "title": "Utsav Chowk",
    "description": "Utsav Chowk in Kharghar is a landmark known for its beautiful architecture, fountains, and well-planned urban layout. It is a favorite gathering spot for locals and tourists, providing photo opportunities and a glimpse of Navi Mumbai’s planned city infrastructure."
  },
  {
    "title": "DY Patil Stadium",
    "description": "DY Patil Stadium in Navi Mumbai is a modern cricket and sports stadium hosting international matches, concerts, and cultural events. Sports enthusiasts visit to watch live games, explore the stadium architecture, and enjoy recreational activities in its vicinity."
  },
  {
    "title": "Seawoods Grand Central Mall",
    "description": "Seawoods Grand Central Mall is a major shopping and entertainment hub in Navi Mumbai, featuring retail outlets, restaurants, cinemas, and leisure zones. Visitors enjoy shopping, dining, and entertainment in a modern and comfortable environment."
  },
  {
    "title": "Rock Garden, Nerul",
    "description": "The Rock Garden in Nerul is a peaceful landscaped area with artistic rock formations, walking paths, and seating spaces. Families, couples, and photography enthusiasts visit for relaxation, nature appreciation, and leisure activities amidst a calm urban setting."
  }
],



"services": [
    {
      "name": "Force Urbania on Rent in Navi Mumbai",
      "description": "Force Urbania on Rent in Navi Mumbai offers high-quality, fully air-conditioned Force Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Each vehicle is well-maintained and driven by professional chauffeurs, ensuring safe, comfortable, and convenient travel throughout Navi Mumbai."
    },
    {
      "name": "Navi Mumbai Urbania Bus Hire",
      "description": "Navi Mumbai Urbania Bus Hire provides spacious and fully air-conditioned Force Urbania buses for group tours, corporate events, school trips, and social gatherings. Comfortable seating and experienced drivers make every journey safe, smooth, and enjoyable."
    },
    {
      "name": "Urbania Rental Service Navi Mumbai",
      "description": "Urbania Rental Service Navi Mumbai delivers premium Force Urbania vehicles for family trips, sightseeing, corporate travel, and leisure outings. Professional chauffeurs ensure reliable, convenient, and safe transportation across Navi Mumbai and nearby destinations."
    },
    {
      "name": "Urbania AC Bus on Rent Navi Mumbai",
      "description": "Urbania AC Bus on Rent Navi Mumbai provides fully air-conditioned Force Urbania buses suitable for long-distance travel, group tours, and corporate outings. Spacious interiors and trained chauffeurs ensure a smooth and comfortable journey."
    },
    {
      "name": "Corporate Urbania Hire Navi Mumbai",
      "description": "Corporate Urbania Hire Navi Mumbai offers professional transportation for office trips, employee commutes, and corporate events. Punctual service and experienced chauffeurs ensure seamless, reliable, and professional travel solutions."
    },
    {
      "name": "Urbania for Outstation Navi Mumbai",
      "description": "Urbania for Outstation Navi Mumbai provides safe and comfortable long-distance travel with well-maintained Force Urbania vehicles. Experienced drivers make trips to nearby cities, tourist destinations, and corporate locations convenient and stress-free."
    },
    {
      "name": "Urbania Airport Transfer Navi Mumbai",
      "description": "Urbania Airport Transfer Navi Mumbai ensures timely pickups and drops for domestic and international airports. Spacious vehicles with professional chauffeurs provide convenient, safe, and hassle-free airport transportation."
    },
    {
      "name": "Luxury Force Urbania Navi Mumbai",
      "description": "Luxury Force Urbania Navi Mumbai offers high-end, fully air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs ensure a premium, stylish, and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Navi Mumbai",
      "description": "Affordable Urbania Hire Navi Mumbai provides budget-friendly Force Urbania rental services without compromising on comfort or reliability. Ideal for families, groups, and corporate clients seeking value-for-money travel."
    },
    {
      "name": "Chauffeur Driven Force Urbania Navi Mumbai",
      "description": "Chauffeur Driven Force Urbania Navi Mumbai offers stress-free travel with trained and verified chauffeurs. Fully air-conditioned vehicles ensure smooth, safe, and comfortable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Navi Mumbai",
      "description": "Urbania for Wedding Events Navi Mumbai provides elegant, fully air-conditioned Force Urbania vehicles for weddings, guest transport, and family travel. Professional chauffeurs ensure timely, stylish, and hassle-free transportation."
    },
    {
      "name": "Urbania for Corporate Travel Navi Mumbai",
      "description": "Urbania for Corporate Travel Navi Mumbai delivers reliable and stylish transportation for business trips, corporate tours, and executive meetings. Punctual service with professional drivers ensures seamless corporate travel experiences."
    },
    {
      "name": "Best Force Urbania Rental Navi Mumbai",
      "description": "Best Force Urbania Rental Navi Mumbai provides top-rated rental services known for reliability, vehicle quality, and customer satisfaction. Suitable for corporate travel, family trips, and group outings requiring premium transportation."
    },
    {
      "name": "Urbania Group Travel Navi Mumbai",
      "description": "Urbania Group Travel Navi Mumbai offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel."
    },
    {
      "name": "Reliable Urbania Hire Navi Mumbai",
      "description": "Reliable Urbania Hire Navi Mumbai offers trustworthy, punctual, and safe Force Urbania rental services. Air-conditioned vehicles with trained chauffeurs provide convenient, comfortable, and dependable travel for all passengers."
    }
  ],
  "tableData": [
    ["Force Urbania on Rent in Navi Mumbai", "Navi Mumbai Urbania Bus Hire"],
    ["Urbania Rental Service Navi Mumbai", "Urbania AC Bus on Rent Navi Mumbai"],
    ["Corporate Urbania Hire Navi Mumbai", "Urbania for Outstation Navi Mumbai"],
    ["Urbania Airport Transfer Navi Mumbai", "Luxury Force Urbania Navi Mumbai"],
    ["Affordable Urbania Hire Navi Mumbai", "Chauffeur Driven Force Urbania Navi Mumbai"],
    ["Urbania for Wedding Events Navi Mumbai", "Urbania for Corporate Travel Navi Mumbai"],
    ["Best Force Urbania Rental Navi Mumbai", "Urbania Group Travel Navi Mumbai"],
    ["Reliable Urbania Hire Navi Mumbai", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Force Urbania On Rent in Navi Mumbai",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai is perfect for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai comes with skilled and courteous drivers familiar with Navi Mumbai routes, highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Force Urbania On Rent in Navi Mumbai for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Force Urbania On Rent in Navi Mumbai are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Force Urbania On Rent in Navi Mumbai guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Force Urbania On Rent in Navi Mumbai available for local and outstation travel?',
        answer: 'Yes, Force Urbania On Rent in Navi Mumbai can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Force Urbania On Rent in Navi Mumbai?',
        answer: 'You can book Force Urbania On Rent in Navi Mumbai via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Force Urbania On Rent in Navi Mumbai?',
        answer: 'Force Urbania On Rent in Navi Mumbai offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Force Urbania On Rent in Navi Mumbai are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Force Urbania On Rent in Navi Mumbai allows flexible pickup and drop locations across Navi Mumbai and nearby areas.',
    },
    {
        question: 'Is Force Urbania On Rent in Navi Mumbai available 24x7?',
        answer: 'Yes, Force Urbania On Rent in Navi Mumbai operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Force Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Force Urbania On Rent in Navi Mumbai accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Force Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Force Urbania On Rent in Navi Mumbai is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Naik',
        feedback: 'Force Urbania On Rent in Navi Mumbai made our corporate trip smooth and comfortable. Spacious, clean, and professional service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Deshmukh',
        feedback: 'We hired Force Urbania On Rent in Navi Mumbai for a family outing. Excellent service and courteous driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rajesh Patil',
        feedback: 'Force Urbania On Rent in Navi Mumbai provided hassle-free travel for our group trip. Highly recommended.',
        rating: 5,
    },
];
























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania On Rent in Navi Mumbai",
  "image": "https://urbaniaonrentpune.in/assets/images/force-urbania-navi-mumbai.jpg",
  "description": "Force Urbania On Rent in Navi Mumbai offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Navi Mumbai and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/force-urbania-on-rent-navi-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Force Urbania On Rent in Navi Mumbai | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Force Urbania On Rent in Navi Mumbai for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Navi Mumbai."
  />

  <meta
    name="keywords"
    content="Force Urbania on Rent in Navi Mumbai, Navi Mumbai Urbania Bus Hire, Urbania Rental Service Navi Mumbai, Urbania AC Bus on Rent Navi Mumbai, Corporate Urbania Hire Navi Mumbai, Urbania for Outstation Navi Mumbai, Urbania Airport Transfer Navi Mumbai, Luxury Force Urbania Navi Mumbai, Affordable Urbania Hire Navi Mumbai, Chauffeur Driven Force Urbania Navi Mumbai, Urbania for Wedding Events Navi Mumbai, Urbania for Corporate Travel Navi Mumbai, Best Force Urbania Rental Navi Mumbai, Urbania Group Travel Navi Mumbai, Reliable Urbania Hire Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Forceurbaniaonrentinnavimumbai;